import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, renderNothing, branch } from 'recompose'
import * as R from 'ramda'

import Grid from 'components/fulcrum/grid/index'
import HeaderMenu from './HeaderMenu'

import styles from './styles.scss'


class Table extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)
    // Determines menu position
    this.menuLeft = 0
    this.scrollLeft = -340
    this.rowHeight = 195
  }

  onCellClick = (distFromLeft, columnIndex) => {
    this.menuLeft = distFromLeft
    this.props.onHeaderClick(columnIndex)
  }

  getMenuStyle = () => ({
    position: 'absolute',
    top: this.rowHeight,
    left: this.props.columnIndex === 0 ? 0 : this.menuLeft - this.scrollLeft
  })
  getProjectLink = (projectID) => {
    return `/project/${projectID}/view`
  }

  render() {
    const {
      active,
      list,
      onMenuHide,
      onSectionRendered,
      columnIndex,
      sortBy,
      sortByValue,
      sortIndex,
      onColumnReorder,
      value,
      sortEnabled,
      onClick,
      onKeyPress,
      onChange,
      inputHeaderSource,
      clickCellAction,
      selectedProjects,
      changedProjects
    } = this.props

    return (
      <React.Fragment>
        <HeaderMenu
          getMenuStyle={this.getMenuStyle}
          active={active}
          onHide={onMenuHide}
          value={value}
          sortBy={sortBy}
          sortEnabled={sortEnabled}
          onClick={onClick}
          onKeyPress={onKeyPress}
          columnIndex={columnIndex}
          onChange={onChange}
          inputHeaderSource={inputHeaderSource}
        />
        <Grid
          list={list}
          sortBy={sortByValue}
          sortIndex={sortIndex}
          loadOnScroll={true} 
          changedProjects={changedProjects}
          onSectionRendered={onSectionRendered}
          showContextMenu={true} 
          onHeaderClick={this.onCellClick}
          onApplyFilter={onClick}
          setColumnReorder={true}
          onColumnReorder={onColumnReorder}
          cellClick={true}
          dynamicData={true}
          // SELECT PROJECTS
          actionOnCellClick={clickCellAction}
          getCellClickURL={this.getProjectLink}
          selectedProjects={selectedProjects}
        />
      </React.Fragment>
    )
  }
}

const withStyle = CSSModules(styles)
const enhance = compose(
  branch(
    compose(R.isEmpty, R.prop('list')),
    renderNothing
  ),
  withStyle,
)

export default enhance(Table)
